import React from 'react';
import SectionHeader from './SectionHeader';
import './HonoursAwards.css';

const honours = [
  {
    year: '2025',
    title: 'Smart India Hackathon National Winner',
    mark: '1st / 68,766',
    description:
      'Won SIH’25 with SAGAR, a spatio-temporal analytics gateway for aquatic resources: an oceanographic data ingestion, research and analysis platform, selected from 68,766 teams nationwide.',
  },
  {
    year: '2024',
    title: 'Smart India Hackathon National Winner',
    mark: '1st / 49,000+',
    description:
      'Won SIH’24 with PARAS, an AI-powered urban transport solution, selected from over 49,000 teams nationwide.',
  },
  {
    year: '2024',
    title: 'Post-Athon Winner',
    mark: 'Winner',
    description:
      'Won India Post’s Post-Athon with an e-commerce platform featuring AI-based delivery time prediction and a logistics aggregation layer, letting small businesses ride India Post’s delivery network.',
  },
  {
    year: '2025',
    title: 'Google Dev Sprint Runner-Up',
    mark: '2nd',
    description:
      '1st Runner-Up at Google Devs Sprint 2K25, organized by Google Developers Group (GDG), recognized for real-time problem-solving.',
  },
];

function HonoursAwards() {
  return (
    <>
      <SectionHeader index="05" label="Recognition" title="On the record" />
      <ol className="honours-ledger">
        {honours.map((item, idx) => (
          <li key={idx} className="honour-row reveal">
            <span className="honour-year">{item.year}</span>
            <div className="honour-body">
              <h3 className="honour-title">{item.title}</h3>
              <p className="honour-desc">{item.description}</p>
            </div>
            <span className="stamp honour-stamp">{item.mark}</span>
          </li>
        ))}
      </ol>
    </>
  );
}

export default HonoursAwards;
